import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    checkbox: {
        padding: 5,
    },
}));

export default useStyles;
